export const LURKER_ACCOUNT_STATUS = {
  ACCOUNT_NOT_FOUND: 'account_not_found',
  ACCOUNT_INACTIVE: 'account_inactive',
  ACCOUNT_LOCKED: 'account_locked',
  ACCOUNT_ON_RED_ZONE: 'account_on_red_zone',
  ACCOUNT_BLOCKED: 'account_blocked',
  ACCOUNT_DISABLED: 'account_disabled',
}
